import { collection, orderBy, query } from 'firebase/firestore'
import AdTemplate from '~/models/adTemplate'

export const useAdTemplateStore = defineStore('adTemplate', () => {
  const db = useFirestore()

  const templatesSource = query(collection(db, `templates`), orderBy('updatedAt', 'desc')).withConverter(AdTemplate)

  const { data: templates, pending, error, promise } = useCollection(templatesSource, { ssrKey: 'allTemplates' })

  return {
    templates,
    pending,
    error,
    promise,
  }
})

export default useAdTemplateStore
